<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div v-loading="isLoading" class="top-spacing container column">
      <div style="padding-bottom:0;" class="full-width">
        <div v-if="images.length > 0" class="image-container">
          <img
            class="left-img"
            :src="images[0]"
            alt="Golf course with green grass fairway and trees with mountains in the background under a clear sky"
          />
          <div class="right-grid">
            <img
              v-for="item in [1, 2, 3, 4]"
              :key="item"
              :src="images[item]"
              :class="{ desktop: item > 3 }"
              alt="Golf course with a large tree on the right and green grass fairway under a partly cloudy sky"
            />
          </div>
        </div>
      </div>
      <div class="mt-20">
        <el-row class="post-container" :gutter="20">
          <el-col :xs="24" :sm="14" :md="14" :lg="16" :xl="16">
            <Info :info="info" />
            <div class="feedback">
              <Feedback :info="info" :facility-id="facilityId" />
            </div>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <div class="top-post-container mb-20">
              <p class="fw-600 m-0 text-uppercase c-body">
                {{ $t("wap.text174") }}
              </p>
            </div>
            <card-news
              v-for="(item, index) in listNews.slice(0, 6)"
              :key="index"
              style="margin-bottom: 15px;"
              class="w-100"
              :object-data="item"
              :excerpt="item.excerpt"
              :title="item.title"
              :banner="item.banner"
              :id="item.post_id"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import ReviewFacility from "@/views/api/wapV2/review-facility";
import { mapGetters, mapActions } from "vuex";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import { getBackGround } from "@/utils/wapAuth";
import CardNews from "@/components/wapV2/cards/CardNews.vue";
import Info from "../components/Info.vue";
import Feedback from "../components/Feedback.vue";

export default {
  name: "reivew-detail-facility",
  components: {
    MainNavBarWapV2,
    Info,
    CardNews,
    Feedback
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  created() {
    this.onGetList();
    this.onGetTopPost();
  },
  mounted() {},
  computed: {
    ...mapGetters(["review_facility"])
  },
  watch: {},

  data() {
    return {
      info: {},
      images: [],
      listNews: [],
      facilityId: this.$route.params.id,
      isLoading: false,
      infoHeader: {
        title: this.$t("wap.text136"),
        isShowHomeIcon: true
      },
      visibleCount: 8,
      bg: getBackGround()
    };
  },
  methods: {
    ...mapActions(["set_data_review_facility"]),
    pushRouter(path) {
      return this.$router.push(path);
    },
    loadMore() {
      this.visibleCount += 8;
    },
    onGetTopPost() {
      ReviewFacility.get_top_post()
        .then(res => {
          const { error_code, data = [] } = res;
          if (error_code === 0 && data.length > 0) {
            const mapData = data.map(i => {
              const obj = {
                ...i,
                id: i.course_id,
                title: i.post.title,
                excerpt: i.post.excerpt,
                banner: i.post.banner
              };
              return obj;
            });
            this.listNews = mapData;
          }
        })
        .finally(() => {});
    },
    onGetList() {
      this.isLoading = true;
      const params = { id: this.$route.params.id };
      ReviewFacility.get_detail_facility(params)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.info = data;
            this.images = data.galleries
              .flatMap(item => item.images?.map(imgObj => imgObj.img))
              .slice(0, 5);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style></style>

<style scoped lang="scss">
.post-container {
  .top-post-container {
    background: #f0f0f0;
    border-left: 4px solid #111827;
    padding: 8px 15px;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
  }
}
.image-container {
  margin: 0 auto;
  display: grid;
  gap: 5px;
  border-radius: 8px;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  min-height: 470px;
  max-height: 525px;
}
.left-img {
  height: 100%;
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
  display: block;
  max-height: 525px;
}
.right-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 5px;
  border-radius: 8px;
  height: 100%;
  margin: 0;
  max-height: 525px;
}
.right-grid img {
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}
.top-spacing {
  padding-top: 100px;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}

@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .image-container {
    grid-template-columns: 2fr 1fr;
    min-height: 300px;
  }
  .left-img {
    width: 100%;
    border-radius: 5px;
    object-fit: cover;
    display: block;
  }
  .right-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    gap: 5px;
  }
  .right-grid img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: cover;
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 591px) {
  .text-see-more {
    font-size: 10px;
  }
}
</style>
